import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { NavItem } from './nav-menu.model';

@Injectable()
export class NavMenuService {
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);

  readonly currentPath = signal<string>(this.router.url);

  constructor() {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
        map((event) => event.urlAfterRedirects),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((url) => this.currentPath.set(url));
  }

  isActive(item: NavItem): boolean {
    const pathSegments = this.currentPath().trim().split('/');
    const primarySegment = pathSegments.find((segment) => segment !== '');

    if (!primarySegment) return false;

    if (item.type === 'group') {
      return item.id.startsWith(primarySegment);
    }

    if (!item.path) return false;

    return this.currentPath().startsWith(item.path);
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
  }
}
